import {
  withTranslation,
} from 'react-i18next';

import AdminSocialUserFieldsView from './AdminSocialUserFieldsView';

const TranslatedComponent = withTranslation()(AdminSocialUserFieldsView);

const Component = TranslatedComponent;

export default Component;
